import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { Occasion } from './occasion.types';

export const useOccasions = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<Occasion[]>>({
    queryKey: 'occasion',
    queryFn: () => apiClient.get<Occasion[]>('/occasions'),
    enabled,
  });
};